import { useForm } from '@/common/form/FormContext';
import { useEffect } from 'react';

// propObj is the fixed owner; when ownerOptions is provided (owner is user-selectable) the currently selected
// option's own object is used instead, so the derived code always reflects the chosen owner.
export const EntityPropCode = ({ propObj, ownerOptions }) => {
  const { formValues, assignValue } = useForm();

  const ownerCode =
    ownerOptions?.find((option) => option.entity === formValues.entity && option.entityId === formValues.entityId)
      ?.ownerObj?.code ?? propObj?.code;

  useEffect(() => {
    if (!ownerCode || !formValues.propCode) return;

    assignValue('code', ownerCode + '_' + formValues.propCode);
  }, [ownerCode, formValues.propCode]);

  return null;
};
